import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

export const getBrandingByDomainName = async (domainName: string) => {
  try {
    const url = "/v1/controlCenter/vanity/domain";
    const response = await axiosClient.post(url, {
      domain: domainName,
    });
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
